// PROD
const firebaseConfig = {
  apiKey: "AIzaSyDfj1jTfg4uHVF06-dRhq_xLj5EK0XwsAQ",
  authDomain: "skrutiner-platform.firebaseapp.com",
  projectId: "skrutiner-platform",
  storageBucket: "skrutiner-platform.appspot.com",
  messagingSenderId: "755090413409",
  appId: "1:755090413409:web:8d9fa344cdd4f36c2fd720",
};

export default firebaseConfig;
